import { __assign, __awaiter, __generator } from "tslib";
import { app } from '@ekuaibao/whispered';
import { Fetch } from '@ekuaibao/fetch';
import { session } from '@ekuaibao/session-info';
import { updatDomainCookie } from '../account.action';
import { selectCorp2UpdateToken } from '@ekuaibao/auth';
export function AuthLoginSelectCorp2UpdateToken(param) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var config, data, updCookieParam, result, token, user, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    Fetch.ekbCorpId = param.corpId;
                    Fetch.corpId = param.corpId;
                    return [4 /*yield*/, app.dataLoader('@common.authEnv').load()];
                case 1:
                    config = _b.sent();
                    return [4 /*yield*/, selectCorp2UpdateToken(__assign(__assign({ environment: config.environment }, param), { host: config.bcGateWayUrl }))
                        // 第一步：更换新得 费控token，第二步：废弃登录接口，使用统一认证接口下发
                        // 更新token->idToken,传递企业id后得，具有企业信息得token
                        // 后续供商城使用
                        // 1.更新Fetch->token
                        // 2.更新session->token
                    ];
                case 2:
                    data = _b.sent();
                    if (!((data === null || data === void 0 ? void 0 : data.code) === "200" || (data === null || data === void 0 ? void 0 : data.code) === 200)) return [3 /*break*/, 7];
                    updCookieParam = {
                        corpId: param.corpId,
                        facadeUrl: "X",
                        hoseAccessToken: data === null || data === void 0 ? void 0 : data.data
                    };
                    _b.label = 3;
                case 3:
                    _b.trys.push([3, 5, , 6]);
                    return [4 /*yield*/, updatDomainCookie(updCookieParam)];
                case 4:
                    result = _b.sent();
                    token = (_a = result === null || result === void 0 ? void 0 : result.value) === null || _a === void 0 ? void 0 : _a.id;
                    if (!!token) {
                        user = session.get('user') || {};
                        Fetch.accessToken = token;
                        session.set('user', __assign(__assign({}, user), { accessToken: token }));
                    }
                    return [3 /*break*/, 6];
                case 5:
                    error_1 = _b.sent();
                    console.log(error_1);
                    return [3 /*break*/, 6];
                case 6: return [3 /*break*/, 8];
                case 7:
                    if ((data === null || data === void 0 ? void 0 : data.code) === "002-001-P-003") {
                        // 后台未开放灰度
                        console.log('------不在灰度测试范围------', data.message);
                    }
                    _b.label = 8;
                case 8: return [2 /*return*/];
            }
        });
    });
}
